import { render, staticRenderFns } from "./adPurchase.vue?vue&type=template&id=2ffdb4db&scoped=true"
import script from "./adPurchase.vue?vue&type=script&lang=js"
export * from "./adPurchase.vue?vue&type=script&lang=js"
import style0 from "./adPurchase.vue?vue&type=style&index=0&id=2ffdb4db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffdb4db",
  null
  
)

export default component.exports